module.exports = __webpack_public_path__ + "img/bg-w-1.495b7996.png";